import { makeOpenSolarStyles } from 'themes/makeOpenSolarStyles'

const PAPER_BACKGROUND_COLOR = 'transparent'

const paperBorder = {
  border: 'none',
}

/** MUI5 Drawer paper theme styles override JSS className — keep the shell invisible. */
export const chatDrawerPaperSx = {
  backgroundColor: 'transparent',
  backgroundImage: 'none',
  boxShadow: 'none',
  border: 'none',
  overflow: 'visible',
  pointerEvents: 'none',
}

/** MUI5 uses OSUI- prefixed class names — target both for UX 2.x and 3.x. */
export const chatDrawerSx = {
  '& .MuiDrawer-paper, & .OSUI-Drawer-paper': chatDrawerPaperSx,
}

export const useChatDrawerStyles = makeOpenSolarStyles((theme) => ({
  root: {
    display: 'flex',
  },
  disconnectedBanner: {
    background: 'white',
    border: '1px solid #0c4fe0',
    borderRadius: 8,
    padding: '12px 12px',
    margin: '12px 12px 0',
    display: 'flex',
  },
  bannerContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    textAlign: 'left',
  },
  bannerHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  disconnectedIcon: {
    fontSize: '18px',
  },

  smallLoadingDots: {
    '& .spinner': {
      width: 'auto',
    },
    '& .spinner > div': {
      width: '8px !important',
      height: '8px !important',
      backgroundColor: '#3984d8 !important',
      margin: '0 2px',
    },
  },
  drawerSide: {
    flexShrink: 0,
    backgroundColor: PAPER_BACKGROUND_COLOR,
  },
  drawerBottom: {
    flexShrink: 0,
    backgroundColor: PAPER_BACKGROUND_COLOR,
  },
  drawerPaperSide: {
    ...paperBorder,
    width: 400,
    height: undefined,
    zIndex: theme.zIndex.adaChatDrawer,
    backgroundColor: PAPER_BACKGROUND_COLOR,
    pointerEvents: 'none',
    overflow: 'visible', // For Drop Shadow
  },
  drawerPaperBottom: {
    ...paperBorder,
    width: 600,
    height: 380,
    zIndex: theme.zIndex.adaChatDrawer,
    position: 'fixed',
    bottom: 30,
    left: '50%',
    marginLeft: -300,
    backgroundColor: PAPER_BACKGROUND_COLOR,
    overflow: 'visible',
    pointerEvents: 'none',
  },
  drawerPaperBottomElevated: {
    ...paperBorder,
    width: 600,
    height: 380,
    zIndex: theme.zIndex.adaChatDrawer,
    position: 'fixed',
    bottom: 70,
    left: '50%',
    marginLeft: -300,
    backgroundColor: PAPER_BACKGROUND_COLOR,
    overflow: 'visible',
    pointerEvents: 'none',
  },
  drawerPaperMobile: {
    ...paperBorder,
    width: '100%',
    zIndex: theme.zIndex.adaChatDrawer,
    backgroundColor: PAPER_BACKGROUND_COLOR,
    overflow: 'visible',
    pointerEvents: 'none',
  },
  chatWindow: {
    borderRadius: 16,
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)',
    display: 'flex',
    flexDirection: 'column',
    pointerEvents: 'auto',
    transition:
      'height 0.4s ease-in-out, min-height 0.4s ease-in-out, max-height 0.4s ease-in-out, background-color 0.2s ease',
    position: 'relative',
  },
  chatWindowDragActive: {
    backgroundColor: '#f0f7ff',
  },
  chatWindowSide: {
    position: 'absolute',
    bottom: 30,
    right: 25,
    left: 8,
    height: 600,
    maxHeight: 'calc(100vh - 100px)',
    minHeight: 400,
  },
  chatWindowSideElevated: {
    position: 'absolute',
    bottom: 70,
    right: 25,
    left: 8,
    height: 600,
    maxHeight: 'calc(100vh - 140px)',
    minHeight: 400,
  },
  chatWindowSideLeft: {
    position: 'absolute',
    bottom: 30,
    left: 25,
    right: 8,
    height: 600,
    maxHeight: 'calc(100vh - 100px)',
    minHeight: 400,
  },
  chatWindowSideLeftElevated: {
    position: 'absolute',
    bottom: 70,
    left: 25,
    right: 8,
    height: 600,
    maxHeight: 'calc(100vh - 140px)',
    minHeight: 400,
  },
  chatWindowBottom: {
    width: '100%',
    height: '100%',
  },
  chatWindowMobile: {
    margin: 8,
    height: 'calc(100% - 16px)',
    marginBottom: 70,
  },
  messagesContainer: {
    flex: 1,
    overflowY: 'scroll',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    backgroundColor: '#fafafa',
    scrollbarGutter: 'stable',
    transition: 'opacity 0.3s ease-out, max-height 0.4s ease-in-out',
    position: 'relative',
    willChange: 'scroll-position',
    // Custom scrollbar styling
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(0, 0, 0, 0.2)',
      borderRadius: '3px',
      '&:hover': {
        background: 'rgba(0, 0, 0, 0.3)',
      },
    },
    '&::-webkit-scrollbar-corner': {
      background: 'transparent',
    },
  },
  inputContainer: {
    padding: '12px 20px',
    backgroundColor: '#ffffff',
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    borderTop: '1px solid rgba(0, 0, 0, 0.08)',
    position: 'relative',
    transition: 'background-color 0.2s ease',
  },
  inputContainerDragActive: {
    backgroundColor: '#f0f7ff',
    borderTop: '2px dashed #1751D0',
  },
  inputField: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    minHeight: '32px',
    borderRadius: 8,
    transition: 'all 0.2s ease',
  },
  sendButton: {
    position: 'absolute',
    top: '50%',
    right: '0px',
    transform: 'translateY(-50%)',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    backgroundColor: 'transparent',
    color: '#1751D0',
    minWidth: 'auto',
    padding: 0,
    boxShadow: 'none',
    '&:disabled': {
      backgroundColor: 'transparent',
      color: '#cccccc',
      boxShadow: 'none',
    },
  },
  voiceButton: {
    position: 'absolute',
    top: '50%',
    right: '40px',
    transform: 'translateY(-50%)',
  },
  chatWindowVoiceMode: {
    backgroundColor: '#f8f9ff',
    overflow: 'hidden',
  },
  voiceModeContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    backgroundColor: '#f8f9ff',
  },
  newMessageButton: {
    position: 'fixed',
    bottom: '150px',
    right: '40px',
    width: '44px',
    height: '44px',
    borderRadius: '12px',
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    color: '#1751D0',
    border: '1px solid rgba(23, 81, 208, 0.15)',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04)',
    zIndex: 5000,
    transition:
      'background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    animation: '$chatDrawerPulse 2s infinite',
    backdropFilter: 'blur(20px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12), 0 4px 16px rgba(0, 0, 0, 0.08)',
      border: '1px solid rgba(23, 81, 208, 0.25)',
    },
  },
  userScrollButton: {
    position: 'fixed',
    bottom: '150px',
    right: '40px',
    width: '44px',
    height: '44px',
    borderRadius: '12px',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    color: '#1751D0',
    border: '1px solid rgba(23, 81, 208, 0.1)',
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.03)',
    zIndex: 5000,
    transition:
      'background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    backdropFilter: 'blur(20px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.05)',
      border: '1px solid rgba(23, 81, 208, 0.2)',
    },
  },
  '@keyframes chatDrawerPulse': {
    '0%': {
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04)',
      transform: 'translateY(0) scale(1)',
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
    },
    '50%': {
      boxShadow: '0 8px 32px rgba(23, 81, 208, 0.25), 0 4px 16px rgba(23, 81, 208, 0.15)',
      transform: 'translateY(-2px) scale(1.05)',
      backgroundColor: 'rgba(255, 255, 255, 1)',
    },
    '100%': {
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04)',
      transform: 'translateY(0) scale(1)',
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
    },
  },
  '@keyframes slideInFromTop': {
    '0%': {
      opacity: 0,
      transform: 'translateY(-10px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  attachedFilesContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: 5,
    gap: 4,
  },
  dragOverlayFull: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(23, 81, 208, 0.08)',
    border: '2px dashed #1751D0',
    borderRadius: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
    zIndex: 1000,
  },
  dragOverlayText: {
    color: '#1751D0',
    fontSize: 16,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
}))
